<template>
    <div class="tabs_content" v-if="entity">
        <section>
            <div class="left">
                <h2 v-translate>Základní nastavení</h2>
            </div>
            <div class="right">
                <div class="field_left">
                    <select-box
                        id="show_carousel"
                        :options="showBooleanOptions"
                        v-model="showCarousel"
                        :disabled="!isEditable"
                        @input="_showCarouselOptionChanged"
                    >
                        <translate class="translate">Zobrazovat carousel</translate>
                    </select-box>
                  <div class="field">
                    <input :disabled="!isEditable || !!!entity.player.carousel" @change="_onShowCarouselEditableChanged" type="checkbox" id="show_carousel_editable" name="show_carousel_editable" :checked="entity.player.carousel ? entity.player.carousel.editable : false">
                    <label for="show_carousel_editable" v-translate>Povolit změnu zobrazování carouselu</label>
                  </div>
                </div>

                <div class="field_right">
                    <select-box
                        id="seeking_speed"
                        :options="seekingSpeedOptions"
                        v-model="seekingSpeed"
                        :disabled="!isEditable"
                        @input="_showSeekingSpeedOptionChanged"
                    >
                        <translate class="translate">Rychlost posouvání rychlosti posunu</translate>
                    </select-box>
                  <div class="field">
                    <input :disabled="!isEditable || !!!entity.player.seeking_speed" @change="_onSeekingSpeedEditableChanged" type="checkbox" id="seeking_speed_editable" name="seeking_speed_editable" :checked="entity.player.seeking_speed ? entity.player.seeking_speed.editable : false">
                    <label for="seeking_speed_editable" v-translate>Povolit změnu rychlosti posunu</label>
                  </div>
                </div>

                <div class="field_left">
                    <select-box
                        id="show_radio_background"
                        :options="showBooleanOptions"
                        v-model="showRadioBackground"
                        :disabled="!isEditable"
                        @input="_showRadioBackgroundOptionChanged"
                    >
                        <translate class="translate">Zobrazovat pozadí při přehrávání rádia</translate>
                    </select-box>
                  <div class="field">
                    <input :disabled="!isEditable || !!!entity.player.show_radio_background" @change="_onShowRadioBackgroundEditableChanged" type="checkbox" id="show_radio_background_editable" name="show_radio_background_editable" :checked="entity.player.show_radio_background ? entity.player.show_radio_background.editable : false">
                    <label for="show_radio_background_editable" v-translate>Povolit změnu zobrazování pozadí přehrávače rádií</label>
                  </div>
                </div>

                <div class="field_right">
                    <select-box
                        id="show_timeline_thumbnails"
                        :options="showBooleanOptions"
                        v-model="showTimelineThumbnails"
                        :disabled="!isEditable"
                        @input="_showTimelineThumbnailsOptionChanged"
                    >
                        <translate class="translate">Zobrazovat náhledy na časové ose</translate>
                    </select-box>
                  <div class="field">
                    <input :disabled="!isEditable || !!!entity.player.show_timeline_thumbnails" @change="_onShowTimelineThumbnailsEditableChanged" type="checkbox" id="show_timeline_thumbnails_editable" name="show_timeline_thumbnails_editable" :checked="entity.player.show_timeline_thumbnails ? entity.player.show_timeline_thumbnails.editable : false">
                    <label for="show_timeline_thumbnails_editable" v-translate>Povolit změnu zobrazování náhledů časové osy</label>
                  </div>
                </div>
              <div class="field_left">
                <select-box
                    id="allow_long_seek"
                    :options="showBooleanOptions"
                    v-model="allowLongseek"
                    :disabled="!isEditable"
                    @input="_allowLongseekOptionChanged"
                >
                  <translate class="translate">Povolit dlouhý posun</translate>
                </select-box>
                <div class="field">
                  <input :disabled="!isEditable || !!!entity.player.allow_long_seek" @change="_onAllowLongseekEditableChanged" type="checkbox" id="allow_long_seek_editable" name="allow_long_seek_editable" :checked="entity.player.allow_long_seek ? entity.player.allow_long_seek.editable : false">
                  <label for="allow_long_seek_editable" v-translate>Povolit změnu dlouhého posunu</label>
                </div>
              </div>
              <div class="field_right">
                <select-box
                    id="show_timeline_thumbnails_long_seek"
                    :options="showBooleanOptions"
                    v-model="showTimelineThumbnailsLongSeek"
                    :disabled="!isEditable"
                    @input="_showTimelineThumbnailsLongSeekChanged"
                >
                  <translate class="translate">Zobrazovat náhledy na časové ose při dlouhém posunu</translate>
                </select-box>
                <div class="field">
                  <input :disabled="!isEditable || !!!entity.player.show_timeline_thumbnails_long_seek" @change="_onShowTimelineThumbnailsLongSeekEditableChanged" type="checkbox" id="show_timeline_thumbnails_long_seek_editable" name="show_timeline_thumbnails_long_seek_editable" :checked="entity.player.show_timeline_thumbnails_long_seek ? entity.player.show_timeline_thumbnails_long_seek.editable : false">
                  <label for="show_timeline_thumbnails_long_seek_editable" v-translate>Povolit změnu zobrazování náhledů časové osy při dlouhém posunu</label>
                </div>
              </div>
              <div class="field_left">
                <select-box
                    id="prefer_ad_track"
                    :options="showBooleanOptions"
                    v-model="preferAdTrack"
                    :disabled="!isEditable"
                    @input="_preferAdTrackOptionChanged"
                >
                  <translate class="translate">Preferovat zvukovou stopu pro nevidomé </translate>
                </select-box>
                <div class="field">
                  <input :disabled="!isEditable || !!!entity.player.prefer_ad_track" @change="_onPreferAdTrackEditableChanged" type="checkbox" id="prefer_ad_track_editable" name="prefer_ad_track_editable" :checked="entity.player.prefer_ad_track ? entity.player.prefer_ad_track.editable : false">
                  <label for="prefer_ad_track_editable" v-translate>Povolit změnu preferované zvukové stopy pro nevidomé</label>
                </div>
              </div>
              <div class="field_right">
                <select-box
                    id="automatic_cc_track"
                    :options="showBooleanOptions"
                    v-model="automaticCcTrack"
                    :disabled="!isEditable"
                    @input="_automaticCcTrackOptionChanged"
                >
                  <translate class="translate">Automatická CC titulková stopa</translate>
                </select-box>
                <div class="field">
                  <input :disabled="!isEditable || !!!entity.player.automatic_cc_track" @change="_onAutomaticCcTrackEditableChanged" type="checkbox" id="automatic_cc_track_editable" name="automatic_cc_track_editable" :checked="entity.player.automatic_cc_track ? entity.player.automatic_cc_track.editable : false">
                  <label for="automatic_cc_track_editable" v-translate>Povolit změnu automatické CC titulkové stopy</label>
                </div>
              </div>
            </div>
        </section>

        <SettingsTable
            :is-editable="isEditable"
            :title="$gettext('Skrývat přehrávač (s)')"
            :value-label="$gettext('Hodnota (s)')"
            :settingsObject="this.entity.player['hide_player_after']"
            sorting-key="hide_player_after"
            @addValue="_onAddValueToHidePlayerAfter"
            @editableChanged="_onEditableHidePlayerAfterChanged"
            @defaultValueChanged="_onDefaultHidePlayerAfterChanged"
            @removeValueByIndex="_onRemoveValueByIndexFromHidePlayerAfter"
            @valuesSorted="_onValuesHidePlayerAfterSorted"
        />

        <section>
            <div class="left">
                <h2 v-translate>HLS.js konfigurace</h2>
            </div>
            <div class="right">
                <div class="field">
                    <JSONTextareaInput
                        id="player_config"
                        v-model="entity.player_config"
                        rows="15"
                        :disabled="!isEditable"
                    >
                        <translate class="translate">JSON konfigurace</translate>
                    </JSONTextareaInput>
                    <div class="field">
                        <input :disabled="!isEditable || !entity.player_config" type="checkbox" id="player_config_merge" name="player_config_merge" v-model="entity.player_config_merge">
                        <label for="player_config_merge" v-translate>Merge s předchozí konfigurací</label>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import formFilterData from "@/components/mixins/form-filter-data"
import settingsMixins from "../mixins/settings";
import SettingsTable from "../../../common/SettingsTable.vue";
import JSONTextareaInput from "../../../common/JSONTextareaInput.vue";

export default {
    name: "Player",
    components: {SettingsTable, JSONTextareaInput},
    mixins: [formFilterData, settingsMixins],
    props: {
        entity: Object,
        isEditable: Boolean,
        availableValues: Object
    },
    data() {
        return {
            showCarousel: this.entity.player.carousel ? this.entity.player.carousel.default : null,
            seekingSpeed: this.entity.player.seeking_speed ? this.entity.player.seeking_speed.default : null,
            showRadioBackground: this.entity.player.show_radio_background ? this.entity.player.show_radio_background.default : null,
            showTimelineThumbnails: this.entity.player.show_timeline_thumbnails ? this.entity.player.show_timeline_thumbnails.default : null,
            showTimelineThumbnailsLongSeek: this.entity.player.show_timeline_thumbnails_long_seek ? this.entity.player.show_timeline_thumbnails_long_seek.default : null,
            allowLongseek: this.entity.player.allow_long_seek ? this.entity.player.allow_long_seek.default : null,
            preferAdTrack: this.entity.player.prefer_ad_track ? this.entity.player.prefer_ad_track.default : null,
            automaticCcTrack: this.entity.player.automatic_cc_track ? this.entity.player.automatic_cc_track.default : null,
        }
    },
    methods: {
        _showSeekingSpeedOptionChanged(value) {
            if (value === null) {
                this._deleteSubkey('player', 'seeking_speed');
            } else {
                this._defaultValueChanged('player', 'seeking_speed', value, this.seekingSpeedAvailableValues);
            }
        },
        _onSeekingSpeedEditableChanged(event) {
            this._editableChanged('player', 'seeking_speed', event.target.checked, this.seekingSpeedAvailableValues);
        },
        _showCarouselOptionChanged(value) {
            if (value === null) {
                this._deleteSubkey('player', 'carousel');
            } else {
                this._defaultValueChanged('player', 'carousel', value === 'true', [true, false]);
            }
        },
        _onShowCarouselEditableChanged(event) {
            this._editableChanged('player', 'carousel', event.target.checked, [true, false]);
        },
        _showRadioBackgroundOptionChanged(value) {
            if (value === null) {
                this._deleteSubkey('player', 'show_radio_background');
            } else {
                this._defaultValueChanged('player', 'show_radio_background', value === 'true', [true, false]);
            }
        },
        _onShowRadioBackgroundEditableChanged(event) {
            this._editableChanged('player', 'show_radio_background', event.target.checked, [true, false]);
        },
        _showTimelineThumbnailsOptionChanged(value) {
            if (value === null) {
                this._deleteSubkey('player', 'show_timeline_thumbnails');
            } else {
                this._defaultValueChanged('player', 'show_timeline_thumbnails', value === 'true', [true, false]);
            }
        },
        _onShowTimelineThumbnailsEditableChanged(event) {
            this._editableChanged('player', 'show_timeline_thumbnails', event.target.checked, [true, false]);
        },
        _showTimelineThumbnailsLongSeekChanged(value) {
          if (value === null) {
            this._deleteSubkey('player', 'show_timeline_thumbnails_long_seek');
          } else {
            this._defaultValueChanged('player', 'show_timeline_thumbnails_long_seek', value === 'true', [true, false]);
          }
        },
        _onShowTimelineThumbnailsLongSeekEditableChanged(event) {
          this._editableChanged('player', 'show_timeline_thumbnails_long_seek', event.target.checked, [true, false]);
        },
        _allowLongseekOptionChanged(value) {
          if (value === null) {
            this._deleteSubkey('player', 'allow_long_seek');
          } else {
            this._defaultValueChanged('player', 'allow_long_seek', value === 'true', [true, false]);
          }
        },
        _onAllowLongseekEditableChanged(event) {
          this._editableChanged('player', 'allow_long_seek', event.target.checked, [true, false]);
        },
        _preferAdTrackOptionChanged(value) {
          if (value === null) {
            this._deleteSubkey('player', 'prefer_ad_track');
          } else {
            this._defaultValueChanged('player', 'prefer_ad_track', value === 'true', [true, false]);
          }
        },
        _onPreferAdTrackEditableChanged(event) {
          this._editableChanged('player', 'prefer_ad_track', event.target.checked, [true, false]);
        },
        _automaticCcTrackOptionChanged(value) {
          if (value === null) {
            this._deleteSubkey('player', 'automatic_cc_track');
          } else {
            this._defaultValueChanged('player', 'automatic_cc_track', value === 'true', [true, false]);
          }
        },
        _onAutomaticCcTrackEditableChanged(event) {
          this._editableChanged('player', 'automatic_cc_track', event.target.checked, [true, false]);
        },
        _onAddValueToHidePlayerAfter(value) {
            this._addValue('player', 'hide_player_after', ~~value);
        },
        _onEditableHidePlayerAfterChanged(value) {
            this._editableChanged('player', 'hide_player_after', value === 'true');
        },
        _onDefaultHidePlayerAfterChanged(value) {
            this._defaultValueChanged('player', 'hide_player_after', ~~value);
        },
        _onRemoveValueByIndexFromHidePlayerAfter(index) {
            this._removeValueByIndex('player', 'hide_player_after', index);
        },
        _onValuesHidePlayerAfterSorted(values) {
            this._replaceValues('player', 'hide_player_after', values.map(Number));
        },
        _getSeekingSpeedValueName(value) {
            switch(value) {
                case 'early':
                    return this.$gettext('Rychlé');
                case 'fair':
                    return this.$gettext('Střední');
                case 'regular':
                    return this.$gettext('Pomalé');
                default:
                    return value;
            }
        }
    },
    computed: {
        seekingSpeedAvailableValues() {
            return this.availableValues.seeking_speed_values;
        },
        seekingSpeedOptions() {
            const values = [{
                id: null,
                text: this.$gettext('Neuplatňuje se')
            }];

            this.seekingSpeedAvailableValues.forEach((availableValue) => {
                values.push({
                    id: availableValue,
                    text: this._getSeekingSpeedValueName(availableValue)
                })
            });

            return values;
        },
        showBooleanOptions() {
            return [{
                id: null,
                text: this.$gettext('Neuplatňuje se')
            },
            {
                id: false,
                text: this.$gettext('Ne')
            }, {
                id: true,
                text: this.$gettext('Ano')
            }];
        },
    },
    watch: {
      'entity.player.carousel'() {
        this.showCarousel = this.entity.player.carousel ? this.entity.player.carousel.default : null;
      },
      'entity.player.seeking_speed'() {
        this.seekingSpeed = this.entity.player.seeking_speed ? this.entity.player.seeking_speed.default : null;
      },
      'entity.show_radio_background'() {
        this.showRadioBackground = this.entity.player.show_radio_background ? this.entity.player.show_radio_background.default : null;
      },
      'entity.player.show_timeline_thumbnails'() {
        this.showTimelineThumbnails = this.entity.player.show_timeline_thumbnails ? this.entity.player.show_timeline_thumbnails.default : null
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/forms/Player.vue